import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { SectionCaption } from './SectionCaption';

interface FormSectionV2Props {
  title: string | ReactNode;
  children: ReactNode;
}

/**
 * Form section with the uppercase caption heading used on social publish flows.
 * Prefer this over FormSection when aligning with SectionCaption page headers.
 *
 * Extra top margin is applied only when the first child hosts an outlined floating
 * label (MUI InputLabel), which sits on the control's top border and otherwise
 * collides with the section caption. Unlabeled first controls are left alone.
 */
export function FormSectionV2({ title, children }: FormSectionV2Props) {
  return (
    <Box mb={4}>
      <SectionCaption title={title} />
      <Stack
        spacing={4}
        sx={{
          '& > *:first-of-type .MuiFormControl-root:has(> .MuiInputLabel-outlined)': {
            mt: 1,
          },
        }}
      >
        {children}
      </Stack>
    </Box>
  );
}
